module.exports = "/_next/static/images/a8ec90abd5074e088b51ec8bfb0c6e39-cartao-proximo-ao-olho-lg@3x.jpg.webp";